import AbstractRightAngledTriangle from "./AbstractRightAngledTriangle";

export default class RightAngledTriangleMirrored extends AbstractRightAngledTriangle {
	static NAME = "right-angled-triangle-mirrored";

	get_name() {
		return RightAngledTriangleMirrored.NAME;
	}

}
